export class EmpresaMRV {
  codigoEmp: string;
  descricaoEmp: string;
  cnpjEmp: string;
  dataCarga: string;
  codFil: string;
  }

  